export const ZINDEX_LOW = 1
export const ZINDEX_MID = 2
export const ZINDEX_HIGH = 3
export const CART = 'cart'
export const PRODUCT_LIST = 'productList'
export const PRODUCT_DETAILS = 'productDetails'
export const noImagUrl =
  'https://i1.zopping.com/zopsmart-media/6026/images/originals/20240629/9cc8938b-a011-4bdb-8c37-d12bec31825f-missingimagegr200.png'
export const REQUIRED_PERSONAL_DETAILS_ERROR =
  'Error need to fill personal details'
export const INVALID_PHONE_NUMBER_ERROR = 'Phone number is invalid'
export const INVALID_ADDRESS_ERROR = 'Error need to fill delivery address.'
export const INVALID_EMAIL_ERROR = 'Please enter a valid email'
export const PHONE_NUMBER_ALREADY_EXISTS_ERROR =
  'Phone number already registered'
export const GOOGLE_MAP_DEFAULT_KEY = 'AIzaSyA6YlEVc6ic84ZWAh2RtlOVsZh8S3fA2pY'
export const GIVE_YOUR_REVIEW_TITLE = 'Give your review title'
export const WRITE_YOUR_REVIEW = 'Write your review here'
export const ENTER_EMAIL_PHONE = 'Enter your email or phone number'
export const ENTER_EMAIL = 'Enter Email'
export const EMAIL_REGEX = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
export const EMAIL_ALREADY_REGISTERED =
  'email is already registered with different customer'
export const HAVE_REFERAL_CODE = 'Enter Referal Code'
export const REFERRAL_CODE_EXPIRED = 'referralCodeIsExpired'
export const REFERAL_CODE_APPLIED = 'referralCodeIsApplied'
export const INVITE_FRIEND_USING_REFERRAL_CODE =
  'Invite your friends using your Referal Code'
export const REFER_FRIEND_NOW = 'Refer your friends now'
export const REFER_A_FRIEND = 'Refer a Friend'
export const HAVE_REFERRAL = 'Have a referral code'
export const REFERRAL_CODE = 'Refer Code :'
export const SEE_MORE_PRODUCT = 'See more products'
export const EARN_UP_TO = 'Earn Up To'
export const FIRST_NAME = 'firstName'
export const LAST_NAME = 'lastName'
export const EMAIL = 'email'
export const PHONE_NUMBER = 'phoneNumberCheckout'
export const EMAIL_OR_PHONE_NUMBER = 'emailOrPhoneNumberSignup'
export const DATE = 'date'
export const SHOW_MORE = 'Show More'
